import React from 'react';
import webservice from "../common/Webservice";
import connect from "react-redux/es/connect/connect";
import PropTypes from "prop-types";
import Tabs from "../pages/Tabs";
import {TABS_STRUCTURE, dispatchUpdateData, capitalize, isApprover, compareTextHtml} from "../misc/Shared";
import Statutes from "./Statutes";
import Measures from "./Measures";
import OtherIssues from "./OtherIssues";
import Editor from "./Editor";
import {AjaxSpinner, Button, PopupWindow, Size, TextArea} from "@utahdts/dts-react-common";
import {isEmpty} from "lodash";
import {iconEye, iconRevert} from "../common/Icon";
import childrenPosition from "@utahdts/dts-react-common/components/form/ChildPosition";
import clone from 'clone';
import moment from 'moment';

const propTypes = {
	currentCobiId:  PropTypes.number.isRequired,

	currentPageTitle: PropTypes.string,

	currentTab:  PropTypes.string.isRequired,

	currentYear:  PropTypes.number.isRequired,

	editing: PropTypes.object.isRequired,
};

const defaultProps = {
};

const mapStateToProps = state => ({
	currentCobiId: state.app.currentCobiId,
	currentPageTitle: state.app.currentPageTitle,
	currentTab: state.app.currentTab,
	currentYear: state.app.currentYear,
	editing: state.app.editing,
});

const CONFIRM_TYPES = {
	SINGLE_TAB: 'single',
	ALL_TABS: 'all_tabs'
};

const STATUS_TYPES = {
	APPROVED: 'public',
	SUBMITTED: 'submitted',
	DRAFT: 'editing',
	REVISE: 'rework'
};

class CobiEditor extends React.Component {
	constructor (props) {
		super(props);

		this.saveTab = this.saveTab.bind(this);
		this.saveAllTabs = this.saveAllTabs.bind(this);
		this.submitTab = this.submitTab.bind(this);
		this.submitAllTabs = this.submitAllTabs.bind(this);
		this.checkTab = this.checkTab.bind(this);
		this.checkAllTabs = this.checkAllTabs.bind(this);
		this.approveTab = this.approveTab.bind(this);
		this.sendBack = this.sendBack.bind(this);
		this.displayMessage = this.displayMessage.bind(this);
		this.hideMessage = this.hideMessage.bind(this);
		this.getComments = this.getComments.bind(this);
		this.postComment = this.postComment.bind(this);
		this.toggleTab = this.toggleTab.bind(this);
		this.toggleCobiId = this.toggleCobiId.bind(this);

		this.state = {
			busy: true,
			html: '',
			status: '',
			showMessage: false,
			message: '',
			comment: '',
			confirm: false,
			confirmType: CONFIRM_TYPES.SINGLE_TAB,
			sendBack: false,
			reason: '',
			draftReady: false,
		};

		this.timer = undefined;
	}

	componentDidMount() {
		this.getInitialData();
	}

	componentDidUpdate(prevProps) {
		if (this.state.draftReady) {
			if ((prevProps.currentCobiId !== this.props.currentCobiId) || (this.props.currentYear !== prevProps.currentYear)) {
				this.setState({busy: true}, () => setTimeout(() => webservice.admin.tab.draft(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(data => this.setState({
					busy: false,
					html: data.text.tabHtml,
					status: data.text.status,
				}, () => this.resetTabs(data))).then(this.getComments), 500));
			} else if ((this.props.currentTab !== prevProps.currentTab)) {
				if (isEmpty(this.props.editing[this.props.currentTab].editor)) {
					this.setState({busy: true}, () => setTimeout(() => webservice.admin.tab.draft(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(data => this.setState({
						busy: false,
						html: data.text.tabHtml,
						status: data.text.status,
					}, () => dispatchUpdateData([
						{path: `app.editing.${this.props.currentTab}`, field: 'original', value: data},
						{path: `app.editing.${this.props.currentTab}`, field: 'editor', value: data},
						{path: `app.editing.${this.props.currentTab}`, field: 'edited', value: false}
					]))).then(this.getComments), 500));
				} else {
					this.setState({
						busy: false,
						html: this.props.editing[this.props.currentTab].editor.text.tabHtml,
						status: this.props.editing[this.props.currentTab].editor.text.status,
					});
				}
			}
		}
	}

	getInitialData() {
		webservice.admin.tab.draft(this.props.currentCobiId, this.props.currentYear, this.props.currentTab).then(data => {
			if(this.props.currentCobiId === data.text.cobiId && this.props.currentTab === data.text.tabName) {
				let newState = {
					busy: false,
					html: data.text.tabHtml,
					status: data.text.status,
					draftReady: true,
				};
				this.setState(newState, () => {
					this.resetTabs(data);
					this.getComments();
				});
			} else {
				this.getInitialData();
			}
		});
	}

	resetTabs(data) {
		const payload = [];
		Object.keys(TABS_STRUCTURE).forEach(key => {
			payload.push(
				{path: `app.editing.${TABS_STRUCTURE[key]}`, field: 'original', value: this.props.currentTab === TABS_STRUCTURE[key] ? data : undefined},
				{path: `app.editing.${TABS_STRUCTURE[key]}`, field: 'editor', value: this.props.currentTab === TABS_STRUCTURE[key] ? data : undefined},
				{path: `app.editing.${TABS_STRUCTURE[key]}`, field: 'edited', value: false}
			);
		});
		dispatchUpdateData(payload);
	}

	getComments() {
		webservice.admin.comment.get(this.props.currentTab, this.props.currentYear, this.props.currentCobiId).then(comments => dispatchUpdateData({path: `app.editing.${this.props.currentTab}`, field: 'comments', value: comments}));
	}

	postComment(field) {
		return webservice.admin.comment.post({
			"comment": this.state[field],
			"cobiId": this.props.currentCobiId,
			"tabName": this.props.currentTab,
			"sessionFiscalYear": this.props.currentYear
		}).then(this.getComments).then(() => this.setState({[field]: ''}));
	}

	renderComments() {
		return this.props.editing[this.props.currentTab].comments.sort((a, b) => {
			a = new Date(a.dateSubmitted);
			b = new Date(b.dateSubmitted);
			return a > b ? -1 : a < b ? 1 : 0;
		}).map(comment => (
			<div className="comment" key={`comment--${comment.id}`}>
				<p className="comment--title">{comment.analystFirstName} {comment.analystLastName}</p>
				<span className="text-medium text-grey">{moment(comment.dateSubmitted).fromNow()}</span>
				<p className="comment--content">{comment.comment}</p>
			</div>
		));
	}

	revertTab() {
		const originalState = clone(this.props.editing[this.props.currentTab].original);
		this.setState({
			busy: false,
			html: originalState.text.tabHtml,
			status: originalState.text.status,
		}, () => dispatchUpdateData([
			{path: `app.editing.${this.props.currentTab}`, field: 'editor', value: originalState},
			{path: `app.editing.${this.props.currentTab}`, field: 'edited', value: false}
		]));
	}

	revertAllTabs() {
		const currentOriginalState = clone(this.props.editing[this.props.currentTab].original);
		this.setState({
			busy: false,
			html: currentOriginalState.text.tabHtml,
			status: currentOriginalState.text.status,
		}, () => {
			const payload = [];
			let originalState;
			Object.keys(TABS_STRUCTURE).forEach(key => {
				originalState = this.props.currentTab === TABS_STRUCTURE[key] ? currentOriginalState : clone(this.props.editing[TABS_STRUCTURE[key]].original);
				payload.push(
					{path: `app.editing.${TABS_STRUCTURE[key]}`, field: 'editor', value: originalState},
					{path: `app.editing.${TABS_STRUCTURE[key]}`, field: 'edited', value: false}
				);
			});
			dispatchUpdateData(payload);
		});
	}

	saveTab() {
		return webservice.admin.tab.update({
			cobiId: this.props.currentCobiId,
			tabName: this.props.currentTab,
			tabHtml: this.state.html,
			sessionFiscalYear: this.props.currentYear
		}).then(() => dispatchUpdateData([
			{path: `app.editing.${this.props.currentTab}.original.text`, field: 'tabHtml', value: this.state.html},
			{path: `app.editing.${this.props.currentTab}.editor.text`, field: 'tabHtml', value: this.state.html},
			{path: `app.editing.${this.props.currentTab}.original.text`, field: 'status', value: STATUS_TYPES.DRAFT},
			{path: `app.editing.${this.props.currentTab}.editor.text`, field: 'status', value: STATUS_TYPES.DRAFT},
			{path: `app.editing.${this.props.currentTab}`, field: 'edited', value: false}
		]))
			.then(() => this.setState({status: STATUS_TYPES.DRAFT}, () => this.displayMessage('Draft saved.')));
	}

	saveAllTabs() {
		let promises = [];
		Object.keys(this.props.editing).filter(key => this.props.editing[key].edited).forEach(tab => {
			promises.push(webservice.admin.tab.update({
				cobiId: this.props.currentCobiId,
				tabName: tab,
				tabHtml: this.props.editing[tab].editor.text.tabHtml,
				sessionFiscalYear: this.props.currentYear
			}).then(() => dispatchUpdateData([
				{path: `app.editing.${tab}.original.text`, field: 'tabHtml', value: this.props.editing[tab].editor.text.tabHtml},
				{path: `app.editing.${tab}.editor.text`, field: 'tabHtml', value: this.props.editing[tab].editor.text.tabHtml},
				{path: `app.editing.${tab}.original.text`, field: 'status', value: STATUS_TYPES.DRAFT},
				{path: `app.editing.${tab}.editor.text`, field: 'status', value: STATUS_TYPES.DRAFT},
				{path: `app.editing.${tab}`, field: 'edited', value: false}
			])));
		});
		return Promise.all(promises).then(() => this.setState({ confirm: false, status: STATUS_TYPES.DRAFT }, () => this.displayMessage('All changes saved.')));
	}

	checkTab() {
		if(this.props.editing[this.props.currentTab].edited) {
			this.setState({confirm: true, confirmType: CONFIRM_TYPES.SINGLE_TAB});
		} else {
			this.submitTab();
		}
	}

	submitTab() {
		return webservice.admin.tab.submit(this.props.currentTab, this.props.currentYear, this.props.currentCobiId).then(() => this.setState({
			confirm: false,
			status: STATUS_TYPES.SUBMITTED
		}, () => {
			this.displayMessage(`${capitalize(this.props.currentTab)} has been submitted.`);
			dispatchUpdateData([
				{path: `app.editing.${this.props.currentTab}.original.text`, field: 'status', value: STATUS_TYPES.SUBMITTED},
				{path: `app.editing.${this.props.currentTab}.editor.text`, field: 'status', value: STATUS_TYPES.SUBMITTED},
			]);
		}));
	}

	submitAllTabs() {
		let promises = [];
		Object.keys(this.props.editing).forEach(tab => {
			this.props.editing[tab].active && promises.push(webservice.admin.tab.submit(tab, this.props.currentYear, this.props.currentCobiId).then(() => dispatchUpdateData([
				{path: `app.editing.${tab}.original.text`, field: 'status', value: STATUS_TYPES.SUBMITTED},
				{path: `app.editing.${tab}.editor.text`, field: 'status', value: STATUS_TYPES.SUBMITTED},
			])));
		});
		return Promise.all(promises).then(() => this.setState({ status: STATUS_TYPES.SUBMITTED }, () => this.displayMessage('All tabs have been submitted.')));
	}

	approveTab() {
		return webservice.admin.tab.approve(this.props.currentTab, this.props.currentYear, this.props.currentCobiId).then(() => this.setState({
			confirm: false,
			status: STATUS_TYPES.APPROVED
		}, () => {
			this.displayMessage(`${capitalize(this.props.currentTab)} has been approved.`);
			dispatchUpdateData([
				{path: `app.editing.${this.props.currentTab}.original.text`, field: 'status', value: STATUS_TYPES.APPROVED},
				{path: `app.editing.${this.props.currentTab}.editor.text`, field: 'status', value: STATUS_TYPES.APPROVED},
			]);
		}));
	}

	sendBack() {
		this.postComment('reason').then(() => webservice.admin.tab.revise(this.props.currentTab, this.props.currentYear, this.props.currentCobiId).then(() => this.setState({
			sendBack: false,
			status: STATUS_TYPES.REVISE
		}, () => {
			this.displayMessage(`${capitalize(this.props.currentTab)} has been sent back.`);
			dispatchUpdateData([
				{path: `app.editing.${this.props.currentTab}.original.text`, field: 'status', value: STATUS_TYPES.REVISE},
				{path: `app.editing.${this.props.currentTab}.editor.text`, field: 'status', value: STATUS_TYPES.REVISE},
			]);
		})));
	}

	toggleTab() {
		return webservice.admin.tab.active(this.props.currentTab, this.props.currentYear, this.props.currentCobiId).then(() => dispatchUpdateData({
			path: `app.editing.${this.props.currentTab}`,
			field: 'active',
			value: !this.props.editing[this.props.currentTab].active
		}));
	}

	toggleCobiId() {
		return webservice.admin.cobiId.active(this.props.currentYear, this.props.currentCobiId).then(() => dispatchUpdateData({
			path: 'app.editing',
			field: 'cobiIdActive',
			value: !this.props.editing.cobiIdActive
		}));
	}

	checkAllTabs() {
		if(Object.keys(this.props.editing).find(key => {return this.props.editing[key].edited})){
			this.setState({confirm: true, confirmType: CONFIRM_TYPES.ALL_TABS});
		} else {
			this.submitAllTabs();
		}
	}

	displayMessage(message) {
		if (this.timer) {
			clearTimeout(this.timer);
			this.timer = undefined;
		}
		this.setState({
			showMessage: true,
			message: message
		}, () => this.timer = setTimeout(this.hideMessage, 2000));
	}

	hideMessage() {
		this.setState({showMessage: false});
		clearTimeout(this.timer);
		this.timer = undefined;
	}

	renderStatus(status) {
		const newStatus = status === 'public' ? 'Approved'
			: status === 'editing' ? 'Draft'
				: capitalize(status);
		return newStatus;
	}

	render() {
		return (
			<React.Fragment>
				{this.state.busy && <AjaxSpinner backdropType={AjaxSpinner.BACKDROPS.COVER_PAGE}/>}
				{this.state.showMessage && <div className="no-backdrop">
					<PopupWindow onBackdropCallback={this.hideMessage}>
						{this.state.message}
					</PopupWindow>
				</div>}
				{this.state.confirm && <PopupWindow
					footerChildren={<React.Fragment>
						<Button label="Cancel"
								onClick={() => this.setState({confirm: false})}
								className="grey"/>
						<Button label="Submit only"
								onClick={this.submitTab}
								className="grey"/>
						<Button label="Save and submit"
								className="blue"
								onClick={() => {
									if (this.state.confirmType === CONFIRM_TYPES.SINGLE_TAB) {
										this.saveTab().then(this.submitTab);
									} else if (this.state.confirmType === CONFIRM_TYPES.ALL_TABS) {
										this.saveAllTabs().then(this.submitAllTabs);
									} else {
										this.displayMessage('Something went wrong. Please try again later.');
									}
								}}/>
					</React.Fragment>}>
					You have unsaved changes. Do you want to save before submitting?
				</PopupWindow>}
				{this.state.sendBack && <PopupWindow
					footerChildren={<React.Fragment>
						<Button label="Cancel"
								onClick={() => this.setState({sendBack: false})}
								className="grey"/>
						<Button label="Send back"
								onClick={this.sendBack}
								className="blue"
								disabled={!/\S/.test(this.state.reason)}/>
					</React.Fragment>}>
					<TextArea field="reason"
							  label="Please enter reason for sending back:"
							  size={Size.FULL_WIDTH}
							  placeholder="Type your comment here..."
							  value={this.state.reason}
							  onChange={(field, value) => this.setState({[field]: value})}/>
				</PopupWindow>}
				<div className="gray-box publish-box publish-box--full m-spacing no-float">
					<div className="publish-box--content clearfix">
						<Button onClick={() => this.revertAllTabs()} label={"Revert all changes"} className="grey mr-spacing float-left mt-spacing-small"
								children={iconRevert()} childrenPosition={childrenPosition.BEFORE} disabled={!Object.keys(this.props.editing).find(key => {return this.props.editing[key].edited})}/>
						<Button onClick={this.saveAllTabs} label={"Save all changes"} className="primary mr-spacing float-left mt-spacing-small"/>
						<div className="float-right mtb-spacing-small flex align-center">
							<span>Set {this.props.currentPageTitle} to {this.props.editing.cobiIdActive ? 'inactive' : 'active'}</span>
							<label className="switch ml-spacing-small">
								<input
									type="checkbox"
									onChange={this.toggleCobiId}
									checked={this.props.editing.cobiIdActive}
								/>
								<span className="slider round"/>
							</label>
						</div>
					</div>
					<div className="publish-box--footer flex flex-end">
						<Button onClick={this.checkAllTabs} label={"Submit all changes"} addWrapper={true} className="blue"/>
					</div>
				</div>
				<Tabs history={this.props.history} />
				<div className="content">
					<div className="flex align-start">
						{this.state.draftReady && <Editor html={this.state.html}
								onChange={model => this.setState({html: model}, () => dispatchUpdateData([{
									path: `app.editing.${this.props.currentTab}.editor.text`,
									field: 'tabHtml',
									value: model
								},{
									path: `app.editing.${this.props.currentTab}`,
									field: 'edited',
									value: !compareTextHtml(this.props.editing[this.props.currentTab].original.text.tabHtml, model)
								}]))}
								counter={false}/>}
						<div className="side-column">
							<div className="gray-box publish-box">
								<h2>Publish tab</h2>
								<div className="publish-box--content">
									<div>Status: <span className="status">{this.renderStatus(this.state.status)}</span></div>
									<div className="mtb-spacing-small flex align-center">
										<span>Set {this.props.currentTab} to {this.props.editing[this.props.currentTab].active ? 'inactive' : 'active'}</span>
										<label className="switch ml-spacing-small">
											<input
												type="checkbox"
												onChange={this.toggleTab}
												checked={this.props.editing[this.props.currentTab].active}
											/>
											<span className="slider round"/>
										</label>
									</div>
									<div className="input-container">
										<a href={`/${this.props.currentYear}/${this.props.currentCobiId}/${this.props.currentTab}/draft`} target="_blank" className="flex-inline flex align-center button-alike">
											{iconEye()}
											<span className="button-label">Preview</span>
										</a>
									</div>
									<Button onClick={() => this.revertTab()} label={"Revert " + this.props.currentTab} addWrapper={true} className="grey" children={iconRevert()}
											childrenPosition={childrenPosition.BEFORE} disabled={!this.props.editing[this.props.currentTab].edited}/>
									<Button onClick={this.saveTab} label={"Save " + this.props.currentTab + " draft"} addWrapper={true} className="primary"/>
								</div>
								<div className="publish-box--footer flex flex-end text-right direction-col">
									<Button onClick={this.checkTab} label={"Submit " + this.props.currentTab + " for approval"} addWrapper={true} className="blue"/>
									{isApprover() && <Button onClick={() => this.setState({sendBack: true})} label={"Send back to analyst"} addWrapper={true} className="orange"/>}
									{isApprover() && <Button onClick={this.approveTab} label={"Approve " + this.props.currentTab} addWrapper={true} className="primary"/>}
								</div>
							</div>
							<p className="italic-text text-medium">* changes need to be saved to preview</p>
							<div className="gray-box publish-box">
								<h2>Comments</h2>
								<div className="publish-box--content">
									<div className="comments">
										{!isEmpty(this.props.editing[this.props.currentTab].comments) && this.renderComments()}
									</div>
									<TextArea field="comment"
											  label="New comment"
											  showLabel={false}
											  size={Size.FULL_WIDTH}
											  placeholder="Type your comment here..."
											  value={this.state.comment}
											  onChange={(field, value) => this.setState({[field]: value})}/>
									<div className="flex flex-end">
										<Button onClick={() => this.postComment('comment')} label="Add" className="primary" disabled={!/\S/.test(this.state.comment)}/>
									</div>
								</div>
							</div>
						</div>
					</div>
					{{
						[TABS_STRUCTURE.ISSUES]: this.props.editing.issues.editor && <OtherIssues issues={this.props.editing.issues.editor.issueText}/>,
						[TABS_STRUCTURE.PERFORMANCE]: this.props.editing.performance.editor && <Measures measures={this.props.editing.performance.editor.measures}/>,
						[TABS_STRUCTURE.BACKGROUND]: this.props.editing.background.editor && <Statutes statutes={this.props.editing.background.editor.statutes}/>
					}[this.props.currentTab]}
				</div>
			</React.Fragment>
		);
	}
}

CobiEditor.propTypes = propTypes;
CobiEditor.defaultProps = defaultProps;

export default connect(mapStateToProps)(CobiEditor);
